<script setup>
import { useElementVisibility, useParentElement } from '@vueuse/core'
const parent = useParentElement()
const panelIsVisible = useElementVisibility(parent, {
  threshold: 0.01,
})
</script>
<template>
  <template v-if="panelIsVisible">
    <slot ref="panel" />
  </template>
  <template v-else>
    <Teleport to="body">
      <div class="sticky-panel stick">
        <div class="container-fluid d-flex gap-2">
          <slot />
        </div>
      </div>
    </Teleport>
  </template>
</template>
